import React from "react";
import { Modal, Spinner } from "@fluentui/react";
import styles from "./PowerplantModal.module.css";
import { FilterPowerplantSettings } from "../FilterPowerplantSettings";
import { PowerplantInfo } from "../../api";
import logo from "../../assets/logo-noglow.png";

// export interface Powerplant {
//     id: string;
//     name: string;
//     [key: string]: any;
// }

interface PowerplantModalProps {
    showPowerplantModal: boolean;
    configLoading: boolean;
    selectedPlantId: string | null;
    powerplants: Record<string, PowerplantInfo>;
    handlePowerplantSelect: (plantId: string) => void;
    isPowerplantLoading: boolean;
}

export const PowerplantModal: React.FC<PowerplantModalProps> = ({
    showPowerplantModal,
    configLoading,
    selectedPlantId,
    powerplants,
    handlePowerplantSelect,
    isPowerplantLoading
}) => {
    const selectedPlantName = selectedPlantId && powerplants[selectedPlantId] ? powerplants[selectedPlantId].name : null;
    console.log("Rendering PowerplantModal with props:", { powerplants });
    return (
        <Modal
            isOpen={showPowerplantModal}
            isBlocking={true}
            styles={{
                main: {
                    background: "transparent",
                    height: "100vh",
                    width: "100vw",
                    maxWidth: "100%",
                    margin: 0,
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }
            }}
        >
            <div className={styles.modalContainer}>
                <div className={styles.modalBox}>
                    <h2 className={styles.title} style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={logo}
                            alt="App Logo"
                            style={{
                                height: "32px",
                                marginRight: "10px",
                                position: "relative",
                                top: "-1px" // fine-tune if needed
                            }}
                        />
                        Select a Powerplant
                    </h2>

                    {configLoading ? (
                        <Spinner label="Loading powerplants..." />
                    ) : isPowerplantLoading ? (
                        <Spinner label={selectedPlantName ? `Loading ${selectedPlantName} configuration...` : "Loading powerplant configuration..."} />
                    ) : (
                        <div className={styles.filterWrapper}>
                            <FilterPowerplantSettings
                                filterPowerplantInputs={selectedPlantId || ""}
                                updateFilterPowerplant={inputs => handlePowerplantSelect(inputs)}
                                label=""
                                powerplants={powerplants}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};
